import type { IContributionProjetRepository } from '../../domain/ports/IContributionProjetRepository';
import type {
  ContributionProjetDTO,
  CreerContributionInput,
  ModifierContributionInput,
  ApiResponse,
} from '../../application/dto/dtos';
import { contributionsProjetApi } from '../api/contributionsProjet.api';

export class ContributionProjetRepository implements IContributionProjetRepository {
  listerParEmploye(idEmploye: string): Promise<ApiResponse<ContributionProjetDTO[]>> {
    return contributionsProjetApi.listerParEmploye(idEmploye);
  }

  listerParProjet(idProjet: string): Promise<ApiResponse<ContributionProjetDTO[]>> {
    return contributionsProjetApi.listerParProjet(idProjet);
  }

  creer(data: CreerContributionInput): Promise<ApiResponse<ContributionProjetDTO>> {
    return contributionsProjetApi.creer(data);
  }

  modifier(idContribution: string, data: ModifierContributionInput): Promise<ApiResponse<ContributionProjetDTO>> {
    return contributionsProjetApi.modifier(idContribution, data);
  }

  supprimer(idContribution: string): Promise<ApiResponse<void>> {
    return contributionsProjetApi.supprimer(idContribution);
  }
}
